module.exports = new __parcel__URL__("project-accordion-skeleton.tpl.cee2df62.svg").toString();